import { OptionButton } from "@/react/components/OptionButton";
import { useAccount, useSocialProviders } from "../hooks";
import { minifyAddress } from "based-shared/utils/minify-address";
import { useSimpleKitContext } from "@/react/context/SimpleKitContext";
import { routes } from "@/react/context/SimpleKitContext";
import { OptionSkeleton } from "@/react/components/OptionSkeleton";
import { getUserProfile } from "based-shared/utils/get-user-profile";
import { useEffect, useState } from "react";

export function SwitchAccount() {
  const { address, network } = useAccount();
  const { isPending } = useSocialProviders();
  const { setPendingItem, setRouter } = useSimpleKitContext();
  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    async function fetchUsers() {
      const user = await getUserProfile(address, network);
      setUsers(user?.users || []);
    }
    fetchUsers();
  }, [address, network]);

  if (isPending) {
    return (
      <div className="web3kit-space-y-2">
        {Array.from({ length: 3 }).map((_, index) => (
          <OptionSkeleton key={index} index={index} className="web3kit-h-12" />
        ))}
      </div>
    );
  }

  return (
    <div className="web3kit-space-y-2">
      {users
        .filter(
          (user) => !(user.address === address && user.network === network)
        )
        .map((user, index) => (
          <OptionButton
            key={index}
            index={index}
            logo={user.image}
            onClick={() => {
              setPendingItem(() => {
                setRouter(routes.switchingAccount);
                return {
                  name: user.name,
                  logo: user.image,
                  args: [
                    {
                      network: user.network,
                      address: user.address,
                    },
                  ],
                  description: `We change your account to "${user.name}".`,
                };
              });
            }}
          >
            {minifyAddress(user.address)}
          </OptionButton>
        ))}
    </div>
  );
}
